<div
  class="h-scroll"
  [class.h-scroll--overflow]="isOverflowing"
  [class.h-scroll--left]="canScrollLeft"
  [class.h-scroll--right]="canScrollRight"
  [class.h-scroll--hint]="hintActive">
  <div class="h-scroll__rail h-scroll__rail--left">
    <button
      type="button"
      class="h-scroll__btn h-scroll__btn--left"
      [class.is-visible]="canScrollLeft"
      [attr.tabindex]="canScrollLeft ? 0 : -1"
      [attr.aria-hidden]="!canScrollLeft"
      (click)="scrollByDirection(-1)">
      <svg class="h-scroll__chevron" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <path d="M9.2 3.4 5.6 8l3.6 4.6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.4 3.4 8.8 8l3.6 4.6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <div class="h-scroll__frame">
    <div
      #viewport
      class="h-scroll__viewport"
      (scroll)="onViewportScroll()">
      <ng-content></ng-content>
    </div>
  </div>

  <div class="h-scroll__rail h-scroll__rail--right">
    <button
      type="button"
      class="h-scroll__btn h-scroll__btn--right"
      [class.is-visible]="canScrollRight"
      [attr.tabindex]="canScrollRight ? 0 : -1"
      [attr.aria-hidden]="!canScrollRight"
      (click)="scrollByDirection(1)">
      <svg class="h-scroll__chevron" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <path d="M3.6 3.4 7.2 8l-3.6 4.6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.8 3.4 10.4 8l-3.6 4.6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div>
